import { InjectionToken } from '@angular/core';

export const IS_MFE_MODE = new InjectionToken<boolean>('Determinate if app is on MFE mode', {
  factory: () => !!(window as any).singleSpaNavigate
});
